import React, { useEffect, useRef, useState } from "react";
import "./header.css";
import logo from "../../assets/logo/logo-only.webp";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const Header = () => {
  const sidebarRef = useRef(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const [pageScrolled, setPageScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
    setShowSidebar(false);
  };

  const handleDropdownClick = (dropdownId) => {
    if (openDropdown === dropdownId) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(dropdownId);
    }
  };

  const handleDropdownLinkClick = () => {
    setOpenDropdown(null);
    scrollHeader();
  };

  const handleClickOutside = (event) => {
    // If the click happens outside the sidebar, close it
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    if (showSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSidebar]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 40) {
        setPageScrolled(true);
      } else {
        setPageScrolled(false);
      }
    };

    // Add the event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <nav
        className={
          pageScrolled
            ? "navbar navbar-expand-md page-scrolled"
            : "navbar navbar-expand-md"
        }
      >
        <div className="navbar-container">
          <div className="navigation-container">
            <div className="logo-container">
              <Link to="/" onClick={() => scrollHeader()}>
                <img alt="logo" src={logo} />
              </Link>
            </div>
            {!showSidebar && (
              <button
                className="navbar-toggler"
                type="button"
                onClick={() => setShowSidebar((prev) => !prev)}
              >
                <FaBars />
              </button>
            )}
          </div>
          <div
            ref={sidebarRef}
            className={
              showSidebar
                ? "mobile-navbar show d-block"
                : "mobile-navbar d-none"
            }
          >
            <div className="mobile-view">
              <div className="image-container">
                <Link to="/" onClick={scrollHeader}>
                  <img src={logo} alt="logo" />
                </Link>
              </div>
              <button
                className="navbar-toggler"
                type="button"
                onClick={() => setShowSidebar(false)}
              >
                <FaTimes />
              </button>
            </div>
            <div className="links-container">
              <div className="nav-item">
                <Link to="/about" className="nav-link" onClick={scrollHeader}>
                  About
                </Link>
              </div>
              <div className="nav-item">
                <a
                  className="nav-link"
                  onClick={() => handleDropdownClick("countries")}
                  role="button"
                  aria-expanded={openDropdown === "countries"}
                >
                  Study Abroad
                </a>
                <div
                  className={
                    openDropdown === "countries" ? "collapse show" : "collapse"
                  }
                >
                  <ul>
                    <li>
                      <Link
                        to="/study-in-uk"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Study in UK
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/study-in-australia"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Study in Australia
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/study-in-japan"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Study in Japan
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/study-in-canada"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Study in Canada
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/study-in-usa"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Study in USA
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="nav-item">
                <a
                  className="nav-link"
                  onClick={() => handleDropdownClick("testPreparations")}
                  role="button"
                  aria-expanded={openDropdown === "testPreparations"}
                >
                  Test Preparations
                </a>
                <div
                  className={
                    openDropdown === "testPreparations"
                      ? "collapse show"
                      : "collapse"
                  }
                >
                  <ul>
                    <li>
                      <Link
                        to="/ielts"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        IELTS
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/pte"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        PTE
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/mock-test"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Mock Test
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="nav-item">
                <Link
                  to="/contact-us"
                  className="nav-link"
                  onClick={scrollHeader}
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
          <div className="desktop-navbar">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  to="/about"
                  className="nav-link"
                  onClick={() => scrollHeader()}
                >
                  About
                </Link>
              </li>
              <li className="nav-item dropdown">
                <p
                  className="nav-link dropdown-toggle"
                  role="button"
                  id="dropdownMenuButton1"
                >
                  Study Abroad
                </p>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <ul>
                    <li>
                      <Link
                        to="/study-in-uk"
                        className="dropdown-item"
                        onClick={() => scrollHeader()}
                      >
                        Study in UK
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/study-in-australia"
                        className="dropdown-item"
                        onClick={() => scrollHeader()}
                      >
                        Study in Australia
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/study-in-japan"
                        className="dropdown-item"
                        onClick={() => scrollHeader()}
                      >
                        Study in Japan
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/study-in-canada"
                        className="dropdown-item"
                        onClick={() => scrollHeader()}
                      >
                        Study in Canada
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/study-in-usa"
                        className="dropdown-item"
                        onClick={() => scrollHeader()}
                      >
                        Study in USA
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>

              <li className="nav-item dropdown">
                <p
                  className="nav-link dropdown-toggle"
                  role="button"
                  id="dropdownMenuButton2"
                >
                  Test Preparation
                </p>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton2"
                >
                  <ul>
                    <li>
                      <Link
                        to="/ielts"
                        className="dropdown-item"
                        onClick={() => scrollHeader()}
                      >
                        IELTS
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/pte"
                        className="dropdown-item"
                        onClick={() => scrollHeader()}
                      >
                        PTE
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/mock-test"
                        className="dropdown-item"
                        onClick={() => scrollHeader()}
                      >
                        Mock Test
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="nav-item">
                <Link
                  to="/contact-us"
                  className="nav-link"
                  onClick={() => scrollHeader()}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
